module.exports = __webpack_public_path__ + "img/ideatwo.cfbf3f66.png";